// extracted by mini-css-extract-plugin
module.exports = {"root":"Viewer_root__1qMwF","header":"Viewer_header__B_S34","creator":"Viewer_creator__2Lr1d","noteDate":"Viewer_noteDate__3kNd0","content":"Viewer_content__3Qg27"};